<div>
  <span class="text-color-secondary">{{ 'LABELS.PRODUCT' | translate }}:</span>
  {{ license.productName }}
</div>

<div>
  <span class="text-color-secondary">{{ 'LABELS.PRODUCT_TYPE' | translate }}:</span>
  {{ 'DB.MODULE.' + license.module.moduleType.code | translate }}
</div>

<div *ngIf="license?.brand">
  <span class="text-color-secondary">{{ 'LABELS.BRAND_NAME' | translate }}:</span>
  {{ license.brand.name }}
</div>

<div *ngIf="license.dealer?.businessName">
  <span class="text-color-secondary">{{ 'LABELS.DEALER' | translate }}:</span>
  {{ license.dealer.businessName }}
</div>

<div>
  <span class="text-color-secondary">{{ 'LABELS.LICENSE_KEY' | translate }}:</span>
  {{ license.licenseKey }}
</div>

<div *ngIf="getLicenseSameActivationTime()">
  <span class="text-color-secondary">{{ 'LABELS.BUNDLE_SERIAL_NUMBER' | translate }}:</span>
  {{ license.licenseBundle.licenseKey }}
</div>

<div *ngIf="license.hwSerialNumber">
  <span class="text-color-secondary">{{ 'LABELS.HW_SERIAL_NUMBER' | translate }}:</span>
  {{ license.hwSerialNumber }}
</div>

<div *ngIf="license.appMode?.code">
  <span class="text-color-secondary">{{ 'LABELS.APP_MODE' | translate }}:</span>
  {{ 'LABELS.APP_MODE.' + license.appMode.code | translate }}
  <br />
</div>

<br />

<div *ngIf="license.maxWorkstations || license.maxWorkstations === 0">
  <span class="text-color-secondary">{{ 'LABELS.MAX_WORKSTATIONS' | translate }}:</span>
  {{ license.maxWorkstations }}
  <br />
</div>

<div>
  <span class="text-color-secondary">{{ 'LABELS.LICENSE_TYPE' | translate }}:</span>
  {{ 'DB.LICENSE_TYPES.CODE.' + license.licenseType.code | translate }}
</div>

<div *ngIf="license.validFrom">
  <span class="text-color-secondary">{{ 'LABELS.VALID_FROM' | translate }}:</span>
  {{ license.validFrom | formatDate: 'P' : true }}
</div>

<div>
  <span class="text-color-secondary">{{ 'LABELS.ACTIVATION_TIME' | translate }}:</span>
  {{ license.activationTime | formatDate: 'P' : true }}
</div>

<div *ngIf="license.licenseDurationTime">
  <span class="text-color-secondary">{{ 'LABELS.LICENSE_DURATION' | translate }}:</span>
  {{ license.licenseDurationTime }} {{ 'LABELS.DAYS' | translate }}
</div>

<div *ngIf="license.licenseDurationUnits">
  <span class="text-color-secondary">{{ 'LABELS.LICENSE_DURATION' | translate }}:</span>
  {{ license.licenseDurationUnits }} {{ 'LABELS.UNITS' | translate }}
</div>

<div *ngIf="license.usedUnits != null">
  <span class="text-color-secondary">{{ 'LABELS.USED_UNITS' | translate }}:</span>
  {{ license.usedUnits || 0 }}
</div>

<div *ngIf="license.usedUnitsLastUpdateTime">
  <span class="text-color-secondary">{{ 'LABELS.USED_UNITS_LAST_UPDATE_TIME' | translate }}:</span>
  {{ license.usedUnitsLastUpdateTime | formatDate: 'P' : true }}
</div>

<div *ngIf="license.expirationTime">
  <span class="text-color-secondary">{{ 'LABELS.EXPIRATION_TIME' | translate }}:</span>
  {{ license.expirationTime | formatDate: 'P' : true }}
</div>

<div>
  <span class="text-color-secondary">{{ 'LABELS.LICENSE_STATE' | translate }}:</span>
  <span [class.text-red-500]="!!license.expired" [class.text-green-500]="!license.expired">
    {{ (!!license.expired ? 'LABELS.EXPIRED' : 'LABELS.ACTIVE') | translate }}
  </span>
</div>

<div class="mt-3">
  <span class="text-color-secondary">{{ 'LABELS.ACTIVATION_TYPE' | translate }}:</span>
  {{ (!!license.offlineActivation ? 'LABELS.OFFLINE' : 'LABELS.ONLINE') | translate }}
</div>

<div *ngIf="license.offlineLicenseKeyExpirationTime || license.licenseBundle?.offlineLicenseKeyExpirationTime" [ngClass]="{ blink: needToBlink }">
  <span class="text-color-secondary">{{ 'LABELS.OFFLINE_LICENSE_KEY_EXPIRATION_TIME' | translate }}:</span>
  <span>{{ license.offlineLicenseKeyExpirationTime ?? license.licenseBundle.offlineLicenseKeyExpirationTime | formatDate: 'P' : true }}</span>
</div>

<div *ngIf="license.offlineLicenseKey || license.licenseBundle?.offlineLicenseKey" class="mt-3">
  <app-license-key-copyable
    [offlineLicenseKey]="license.offlineLicenseKey ?? license.licenseBundle.offlineLicenseKey"
    [licenseKey]="license.licenseBundle?.licenseKey ?? license.licenseKey"
    [showOfflineLicenseKey]="false"
    (onRenewOfflineLicenseKey)="renewOfflineLicense()"
    [ngClass]="{ blink: needToBlink }"
  ></app-license-key-copyable>
</div>